var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#CECECE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 27.25C28.8547 27.25 28.2078 28 26 28C23.7922 28 23.15 27.25 21.8 27.25C18.3219 27.25 15.5 30.0719 15.5 33.55V34.75C15.5 35.9922 16.5078 37 17.75 37H34.25C35.4922 37 36.5 35.9922 36.5 34.75V33.55C36.5 30.0719 33.6781 27.25 30.2 27.25ZM34.25 34.75H17.75V33.55C17.75 31.3188 19.5687 29.5 21.8 29.5C22.4844 29.5 23.5953 30.25 26 30.25C28.4234 30.25 29.5109 29.5 30.2 29.5C32.4313 29.5 34.25 31.3188 34.25 33.55V34.75ZM26 26.5C29.7266 26.5 32.75 23.4766 32.75 19.75C32.75 16.0234 29.7266 13 26 13C22.2734 13 19.25 16.0234 19.25 19.75C19.25 23.4766 22.2734 26.5 26 26.5ZM26 15.25C28.4797 15.25 30.5 17.2703 30.5 19.75C30.5 22.2297 28.4797 24.25 26 24.25C23.5203 24.25 21.5 22.2297 21.5 19.75C21.5 17.2703 23.5203 15.25 26 15.25Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/iconAvatar.017b36d3d88bbc6d6f8609b05b7dec21.svg";
export { ForwardRef as ReactComponent };